/* eslint-disable */
import React from 'react';
import './MainLogo.styles.css';

const MainLogo = () => {
  return (
    <div className="MainLogobox">
      <img
        className="MainLogo"
        src={require('../../assets/images/MTH-Color-logo.svg').default}
        alt="Logo"
      />
    </div>
  );
};

export default MainLogo;
